import { getExerciseTypeVersionAdapter } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('RemoteDesktopExercise', 'v5');
export default exerciseTypeVersionAdapter;